import React from 'react';
import PropTypes from 'prop-types';
import { get, has } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Image, withSize } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import { colors } from '../styles';

const styles = css`
  padding: 0;
  margin: 0 -15px;
  @media (min-width: 540px) {
    margin: 0;
    padding: 45px 0;
  }
  .Carousel_thumbnailsWrapper {
    display: block;
    position: relative;
    margin: 0;
    @media(min-width: 992px) {
      margin: 0;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      white-space: nowrap;
      overflow-x: scroll;
      scroll-behavior: smooth;
    }
  }

  .Carousel_thumbnailItem {
    display: inline-block;
    white-space: nowrap;
    position: relative;
    margin: 0;
    width: 25%;
    background-color: transparent;
    cursor: pointer;
    @media(min-width: 992px) {
      margin: 0 0 0 0;
      width: 14.2857%;
    }
    &:focus {
      outline: none;
    }
    &:nth-child(4) {
      .Carousel_overlay {
        display: flex;
        @media(min-width: 992px) {
          display: none;
        }
      }
    }
    &:nth-child(7) {
      .Carousel_overlay {
        @media(min-width: 992px) {
          display: flex;
        }
      }
    }
  }
  .Carousel_thumbnailItemBtn {
    &:focus {
      outline: none;
    }
  }
  .Carousel_thumbnailItem:after {
    display: none;
    content: " ";
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    height: 8px;
    position: absolute;
    background-color: ${colors.brand3};
    z-index: 1;
    pointer-events: none;
  }
  .Carousel_thumbnailItem:before {
    content: '';
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    pointer-events: none;
    display: none;
  }
  .Carousel_thumbnailItem-active:after, .Carousel_thumbnailItem-active:before {
    display: block;
  }
  img {
    width: 100%;
    height: auto;
  }
  .Carousel_videoOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url('/images/icon-play-button-white.svg');
    background-size: 45px 45px;
    background-color: rgba(57, 57, 57, 0.8);
    background-position: center center;
    background-repeat: no-repeat;
  }
  .Carousel_tourOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    background-image: url('/images/icon-tour-white.svg');
    background-position: center center;
    background-size: auto 34px;
    background-repeat: no-repeat;
  }
  .Carousel_overlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    font-weight: 800;
    font-size: 18px;
    color: ${colors.white};
    letter-spacing: 0;
    display: none;
    justify-content: center;
    align-items: center;
    animation: fadeIn .3s;
    @media(min-width: 992px) {
      font-size: 28px;
    }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
      to { opacity: 1; }
  }
  @keyframes fadeOut {
     0% {opacity: 1;}
     100% {opacity: 0;}
  }
  .Carousel_overlayAlt {
    animation: fadeOut 0.5s forwards;
  }
   .Carousel_image {
    position: relative;
    padding-bottom: 54.9%;
    position: relative;
    @media(min-width: 768px) {
      padding-bottom: 56.25%;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transform: scaleX(-1);
      background-image: linear-gradient(173deg, rgba(0,0,0,0.00) 48%, rgba(0,0,0,0.35) 100%);
    }
    img {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      height: 100%;
      @media(min-width: 992px) {
        height: auto;
      }
    }
    .Carousel_imageElement {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      margin: 0;
      padding: 0;
      width: 100%;
    }
    iframe {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .Carousel_imageButtonLeft, .Carousel_imageButtonRight {
    position: absolute;
    display: block;
    top: 40%;
    width: 25px;
    height: 25px;
    background-size: 25px 25px;
    background-position: center center;
    background-repeat: no-repeat;
    z-index: 2;
    cursor: pointer;
    @media (min-width: 992px) {
      top: 45%;
      width: 42px;
      height: 42px;
      background-size: 42px 42px;
    }
    &:focus {
      outline: none;
    }
  }
  .Carousel_imageButtonLeft {
    background-image: url('/images/icon-arrow-left-white-shadow.svg');
    left: 20px;
    @media(min-width: 992px) {
      left: 40px;
    }
  }
  .Carousel_imageButtonRight {
    background-image: url('/images/icon-arrow-right-white-shadow.svg');
    right: 20px;
    @media(min-width: 992px) {
      right: 40px;
    }
  }
  .Carousel_imageEnlarge {
    position: absolute;
    display: block;
    width: 28px;
    height: 28px;
    right: 0;
    bottom: 0;
    cursor: pointer;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.8);
    @media(min-width: 992px) {
      width: 55px;
      height: 55px;
    }
    &::before {
      content: '';
      background-image: url('/images/icon-expand-white.svg');
      background-size: contain;
      display: flex;
      width: 13px;
      height: 13px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media(min-width: 992px) {
        width: 26px;
        height: 26px;
      }
    }
  }
  .Carousel_h2Wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 45px;
    z-index: 1;
  }
  .Carousel_h2 {
    display: flex;
    flex-direction: column;
    font-weight: 700;
    font-size: 50px;
    color: ${colors.white};
    letter-spacing: 1px;
    line-height: 1;
    text-shadow: 0 10px 15px rgba(0, 0, 0, 0.5);
    margin: 0 0 15px 0;
    span {
      font-weight: 700;
      text-transform: uppercase;
      font-size: 20px;
      color: ${colors.white};
      letter-spacing: 3px;
    }
  }
  .Carousel_h2Metro {
    height: 45px;
    width: max-content;
    padding: 5px 30px;
    display: felx;
    align-items: center;
    background-color: ${colors.brand2};
    font-weight: 800;
    text-transform: uppercase;
    font-size: 18px;
    color: ${colors.body};
    letter-spacing: 2px;
  }
  .Carousel_list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-start;
  }
  .Carousel_listItem {
    font-size: 16px;
    line-height: 1;
    font-weight: 400;
    color: ${colors.white};
    margin: 0 10px 0 0;
    padding: 0 10px 0 0;
    border-right: 1px solid ${colors.white};
    &:last-child {
      border: 0;
    }
  }
  .Carousel_listItemLabel {
    margin: 0 0 0 5px;
  }
  .Carousel_listItemValue {
    font-weight: 700;

  }
`;

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: props.items[0],
      overlay: true,
    };
  }

  componentDidUpdate() {
    if (!this.props.items.includes(this.state.currentSlide)) {
      this.setCurrentSlide(this.props.items[0]);
    }
  }

  componentWillUnmount() {
    if (this.thumbnailListRef) {
      this.thumbnailListRef.removeEventListener('scroll', this.handleAddClassOnScroll);
    }
  }

  setCurrentSlide = slide => {
    this.setState({
      currentSlide: slide,
    });
  }

  setThumbnailListRef = ref => {
    if (ref) {
      this.thumbnailListRef = ref;
      this.thumbnailListRef.addEventListener('scroll', this.handleAddClassOnScroll);
    }
  }

  handleThumbnailClick = item => event => {
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    this.setState({
      currentSlide: item,
    }, this.scrollToActiveThumb);
  }

  handlePrevClick = (event = {}) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    const { items } = this.props;
    const { currentSlide } = this.state;
    const currentIndex = items.indexOf(currentSlide);
    const prevIndex = (currentIndex + (items.length - 1)) % items.length;
    this.setState({
      currentSlide: items[prevIndex],
    }, this.scrollToActive);
  }

  handleNextClick = (event = {}) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    const { items } = this.props;
    const { currentSlide } = this.state;
    const currentIndex = items.indexOf(currentSlide);
    const nextIndex = (currentIndex + 1) % items.length;
    this.setState({
      currentSlide: items[nextIndex],
    }, this.scrollToActive);
  }

  handleTouchStart = event => {
    this.xDown = event.touches[0].clientX;
    this.xDownTime = Date.now();
  }

  handleTouchEnd = event => {
    const swipeDifference = this.xDown - event.changedTouches[0].clientX;
    if (Date.now() - this.xDownTime < 50) {
      event.target.click();
      return;
    }

    if (swipeDifference > 9) {
      this.handleNextClick();
    } else if (swipeDifference < -9) {
      this.handlePrevClick();
    }
  }

  scrollToActive = () => {
    if (this.thumbnailListRef) {
      const { offsetLeft = 0, offsetWidth: thumbWidth } = this.thumbnailListRef.getElementsByClassName('Carousel_thumbnailItem-active')[0];
      const containerWidth = this.thumbnailListRef.offsetWidth;
      const scrollLeft = this.thumbnailListRef.scrollLeft;

      if ((offsetLeft + thumbWidth) > (
        containerWidth + scrollLeft
      )) {
        this.thumbnailListRef.scrollLeft = offsetLeft;
      } else if (offsetLeft < scrollLeft) {
        this.thumbnailListRef.scrollLeft = (offsetLeft + thumbWidth) - containerWidth;
      }
    }
  }

  scrollToActiveThumb = () => {
    if (this.thumbnailListRef) {
      const { offsetLeft = 0, offsetWidth: thumbWidth } = this.thumbnailListRef.getElementsByClassName('Carousel_thumbnailItem-active')[0];
      const scrollLeft = this.thumbnailListRef.scrollLeft;

      if ((offsetLeft + thumbWidth) > scrollLeft) {
        this.thumbnailListRef.scrollLeft = offsetLeft;
      }
    }
  }

  handleAddClassOnScroll = () => {
    const { overlay } = this.state;
    const ref = this.thumbnailListRef;
    if (ref.scrollLeft > 15 && overlay === true) {
      this.setState({
        overlay: false,
      });
    } else if (ref.scrollLeft < 15 && overlay === false) {
      this.setState({
        overlay: true,
      });
    }
  };

  render() {
    const {
      expandButton,
      expandButtonContent,
      items,
      thumbnails,
      thumbnailImageProps,
      mainImageProps,
      carouselTitle,
      carouselSubtitle,
      carouselList,
      metro,
      size,
    } = this.props;
    const { currentSlide, overlay } = this.state;
    return (
      <div
        className={styles}
      >
        <div
          className="Carousel_image"
          onTouchStart={this.handleTouchStart}
          onTouchEnd={this.handleTouchEnd}
        >
          {
            has(currentSlide, 'contentUrl') &&
            <Image
              src={get(currentSlide, 'contentUrl')}
              alt={get(currentSlide, 'name', get(currentSlide, 'caption', ''))}
              {...mainImageProps}
            />
          }
          {
            has(currentSlide, 'element') &&
            get(currentSlide, 'element')
          }
          {
            items.indexOf(currentSlide) > 0 &&
            <div
              role="button"
              tabIndex="0"
              onClick={this.handlePrevClick}
              onKeyDown={this.handlePrevClick}
              className="Carousel_imageButtonLeft"
            />
          }
          {
            items.length > 1 &&
            (items.indexOf(currentSlide) + 1) < items.length &&
            <div
              role="button"
              tabIndex="0"
              onClick={this.handleNextClick}
              onKeyDown={this.handleNextClick}
              className="Carousel_imageButtonRight"
            />
          }
          {
            expandButton &&
            <LightBox items={items} enableZoom>
              <div className="Carousel_imageEnlarge" data-index={items.indexOf(currentSlide)}>
                {
                  !expandButtonContent &&
                  <div className="Carousel_imageEnlargeButton" data-index={items.indexOf(currentSlide)} />
                }
                {expandButtonContent}
              </div>
            </LightBox>
          }
          {
            carouselTitle && size.width >= 992 &&
            <div className="Carousel_h2Wrapper">
              <h2 className="Carousel_h2">
                {carouselTitle}
                <span className="DetailsPage_h2">{carouselSubtitle}</span>
              </h2>
              {
                metro &&
                <span className="Carousel_h2Metro">{metro}</span>
              }
              {
                carouselList && size.width >= 992 &&
                <div>
                  {carouselList}
                </div>
              }
            </div>
          }
        </div>
        {
          thumbnails &&
          <div className="Carousel_thumbnailsWrapper">
            <ul ref={ref => this.setThumbnailListRef(ref)}>
              {
                items.map((item, i) => (
                  <li key={i.toString()} className={`Carousel_thumbnailItem ${currentSlide === item ? 'Carousel_thumbnailItem-active' : ''}`}>
                    <span
                      role="button"
                      tabIndex="0"
                      onClick={this.handleThumbnailClick(item)}
                      onKeyDown={this.handleThumbnailClick(item)}
                      className="Carousel_thumbnailItemBtn"
                    >
                      {
                        (has(item, 'contentUrl') && item.type !== 'video') &&
                        <Image
                          src={get(item, 'contentUrl')}
                          alt={get(item, 'name', get(item, 'caption', ''))}
                          {...thumbnailImageProps}
                        />
                      }
                      {
                        item.type === 'video' &&
                        <Image
                          src={get(item, 'thumb')}
                          alt={get(item, 'name', get(item, 'caption', ''))}
                          {...thumbnailImageProps}
                        />
                      }
                      {
                        (!has(item, 'contentUrl') && item.type !== 'video') &&
                        <Image
                          src={get(items, '[0]contentUrl')}
                          alt={get(items, '[0]name', get(items, '[0]caption', ''))}
                          {...thumbnailImageProps}
                        />
                      }
                      {
                        item.type === 'video' &&
                        <div className="Carousel_videoOverlay" />
                      }
                      {
                        item.type === 'tour' &&
                        <div className="Carousel_tourOverlay" />
                      }
                      {
                        items.length - (i + 1) > 0 &&
                        <div className={`Carousel_overlay  ${!overlay ? 'Carousel_overlayAlt' : ''}`}>+{items.length - (i + 1)}</div>
                      }
                    </span>
                  </li>
                ))
              }
            </ul>
          </div>
        }
      </div>
    );
  }
}

Carousel.propTypes = {
  expandButton: PropTypes.bool,
  carouselTitle: PropTypes.string.isRequired,
  carouselSubtitle: PropTypes.string.isRequired,
  carouselList: PropTypes.string.isRequired,
  metro: PropTypes.string,
  size: PropTypes.object.isRequired,
  expandButtonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  items: PropTypes.arrayOf(PropTypes.shape({
    contentUrl: PropTypes.string,
    element: PropTypes.node,
    name: PropTypes.string,
    caption: PropTypes.string,
  })).isRequired,
  thumbnails: PropTypes.bool,
  mainImageProps: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    exact: PropTypes.bool,
    preserve: PropTypes.bool,
  }).isRequired,
  thumbnailImageProps: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    exact: PropTypes.bool,
    preserve: PropTypes.bool,
  }),
};

Carousel.defaultProps = {
  expandButton: true,
  expandButtonContent: undefined,
  thumbnails: false,
  thumbnailImageProps: undefined,
  metro: undefined,
};

export default withSize()(Carousel);



// WEBPACK FOOTER //
// ./src/components/CarouselDetailPages.js